var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundedDarkShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 10.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.3,18.64a.3.3,0,0,1-.3-.3V.3A.3.3,0,0,1,.3,0,.3.3,0,0,1,.6.3V18.037H18.34a.3.3,0,0,1,0,.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.089,9.441a.3.3,0,0,1,0-.423L8.5.6H.3A.3.3,0,0,1,.3,0H9.229a.3.3,0,0,1,.264.16.3.3,0,0,1,.035.16V9.229a.3.3,0,0,1-.088.212.29.29,0,0,1-.212.088.3.3,0,0,1-.3-.3v-8.2L.515,9.441A.3.3,0,0,1,.3,9.53.294.294,0,0,1,.089,9.441Z",
    transform: "translate(6.675 2.485)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedDarkShare);
export default __webpack_public_path__ + "static/media/icon_rounded_dark_share.ddeec1ae7cdffdbd92c620ad2804113e.svg";
export { ForwardRef as ReactComponent };